
import { defineComponent, ref, onMounted, computed, watch } from "vue";

import { store } from "@/store";

import ToolTitle from "./ToolTitle.vue";

import usePickr from "@/composables/usePickr";

import { ActionTypes } from "@/store/actions";
import { ColorPickrState } from "@/types";

import data from "@/data/colors.json";

interface Color {
  title: string;
  hex: string;
}

export default defineComponent({
  name: "Background",
  components: {
    ToolTitle,
  },
  setup() {
    const title = ref("");
    const colors = ref<Color[]>(data.colors);
    const customColor = ref<HTMLDivElement>();

    const currentBgColor = computed<string>(() => store.getters.currentLabelBgColor);

    onMounted(() => {
      if (customColor.value) {
        if (currentBgColor.value.length) {
          customColor.value.style.backgroundColor = currentBgColor.value;
        } else {
          customColor.value.style.backgroundColor = "#fff";
        }
      }

      title.value = "Background";
    });

    watch(currentBgColor, (newState) => {
      if (customColor.value) {
        customColor.value.style.backgroundColor = newState;
      }
    });

    const colorPickrState = computed<ColorPickrState>(() => store.getters.colorPickrState);
    const openColorPickr = () => {
      if (customColor.value) {
        if (colorPickrState.value.isOpen) {
          let payload = {
            ...colorPickrState.value,
            isOpen: true,
            id: "canvas-bg-color",
            property: {
              name: "",
              value: "",
            },
          };

          usePickr(payload);
        } else {
          let payload = {
            ...colorPickrState.value,
            isOpen: false,
            id: "canvas-bg-color",
            property: {
              name: "fill",
              value: customColor.value.style.backgroundColor,
            },
          };

          usePickr(payload);
        }
      }
    };

    const chooseColor = (hex: string) => {
      if (customColor.value) {
        customColor.value.style.backgroundColor = hex;
      }

      store.dispatch(ActionTypes.SET_LABEL_BG_COLOR, hex);
    };

    return {
      title,
      colors,
      customColor,
      openColorPickr,
      chooseColor,
    };
  },
});
